import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ACTIVE_LOANS_FEATURE_KEY, AVAILABLE_LOANS_FEATURE_KEY, getActiveLoansReducer, getAvailableLoansReducer, loanPurposesReducer, LOAN_PURPOSES_FEATURE_KEY } from './data-access/store/reducers';
import { LoansEffects } from './data-access/store/effects';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(AVAILABLE_LOANS_FEATURE_KEY, getAvailableLoansReducer),
    StoreModule.forFeature(ACTIVE_LOANS_FEATURE_KEY, getActiveLoansReducer),
    StoreModule.forFeature(LOAN_PURPOSES_FEATURE_KEY, loanPurposesReducer),
    EffectsModule.forFeature([LoansEffects]),
  ],
})
export class SbkFeatureLoansModule { }
